import myDetails from "../assets/myDetails.json";

import Header from '../components/Header';
import Footer from '../components/Footer';
import BackBtn from '../components/BackBtn';
import PhotoSlideshow from '../components/PhotoSlideshow';
import TimeLine from "../components/TimeLine";

function Bio() {

    const page_title = "Bio"

    return (
        <div className='home-main'>
            <div className='sub-sec'>
                <Header title={page_title} />
                <TimeLine />
                <div className='body-grid'>
                    {
                        myDetails.summary.slice(1).map((content) => (
                            <div>
                                <div className="grid-title">{content[0]}</div>
                                <hr></hr>
                                <div>{content[1]}</div>
                            </div>
                        ))
                    }
                    <div>
                        <div className="grid-title">Languages</div>
                        <hr></hr>
                        <div className='cnt-grid-logo'>
                            {myDetails.languages.map(([lang, symbol]) => (
                                <div className='sm-cnt-btn'>
                                    <div className='lang-font'>{symbol}</div>
                                    <div>{lang}</div>
                                </div>
                            ))}
                        </div>
                    </div>
                    <div>
                        <div className="grid-title">Photography</div>
                        <hr></hr>
                        <div>
                            <div className='grid-body-sub-title'>Random pics by me</div>
                            <PhotoSlideshow />
                        </div>
                    </div>
                </div>
                <BackBtn title={page_title} />
            </div>
            <Footer />
        </div>
    );
}

export default Bio;